import _Vue from 'vue';

import axiosManager from './axiosManager';

var AxiosGlobal: axiosManager = new axiosManager();

export default function axiosDirectPlugIn(Vue: typeof _Vue): void {
    Vue.prototype.$Direct = AxiosGlobal;
}